import {useCurrentBreakpoint} from '@travel-frontend/core';
import {TrustElements as SharedTrustElements} from '@travel-frontend/ui-components';
import {memo, useMemo} from 'react';

import {type BlockTrustElements} from '@/api/pageService';
import {useConfig} from '@/modules/common/context/Config';
import * as pageServiceUtils from '@/modules/common/queries/pageService/utils';

export const TrustElements = memo(function TrustElements() {
  const config = useConfig();
  const breakpoint = useCurrentBreakpoint();

  const {headline, elements} = useMemo(() => {
    try {
      const trustElementsBlock =
        pageServiceUtils.findContentBlockItem<BlockTrustElements>({
          deviceId: pageServiceUtils.mapBreakpointToDeviceId(breakpoint),
          collectionId: 'block_trust_elements',
          config: config.pageService,
        });

      return {
        headline: trustElementsBlock?.headline?.text,
        elements:
          trustElementsBlock?.items.map((item) => ({
            keyfact: item.keyfact,
            image: pageServiceUtils.resolveImageUrl(item.image),
            link: {
              title: item.linkTitle ?? '',
              url: item.linkURL ?? '',
            },
          })) ?? [],
      };
    } catch {
      // Just in case pageService returns something unexpected
      return {
        headline: '',
        elements: [],
      };
    }
  }, [config.pageService, breakpoint]);

  if (elements.length === 0) {
    return null;
  }

  return <SharedTrustElements headline={headline} elements={elements} />;
});
